import { RootState } from "@/redux/store";

export const premiumAddOnsSelector = (state: RootState) => state.addOn.premiumAddOns;
export const addOnsSelector = (state: RootState) => state.addOn.addOns;
export const featuredAddOnsSelector = (state: RootState) => state.addOn.featuredAddOns;
export const addOnItemSelector = (id: string) => (state: RootState) =>
  [...state.addOn.premiumAddOns, ...state.addOn.addOns].find((a) => a.identifier === id);
